import { toast, type ToastOptions } from 'react-toastify';

import { NotificationType } from 'types/enums';

type Message = string | undefined;

class Notification {
  private show(message: Message, parameters: ToastOptions): void {
    toast(message, parameters);
  }

  public [NotificationType.INFO] = (message: Message): void => {
    this.show(message, { type: 'info', draggable: false });
  };
  public [NotificationType.SUCCESS] = (message: Message): void => {
    this.show(message, { type: 'success', draggable: false });
  };
  public [NotificationType.WARNING] = (message: Message): void => {
    this.show(message, { type: 'warning', draggable: false });
  };
  public [NotificationType.ERROR] = (message: Message): void => {
    this.show(message, { type: 'error', draggable: false });
  };
}

export { Notification };
